import React, { useEffect, useState } from "react";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClientXml from "../../utils/HttpClientXml";
import HomeServices from "../../Services/HomeServices";
import "./Pages.css";
import Swal from "sweetalert2";
import { Form, Link, useLocation, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BackPageBtn from "../BackButton/BackPageBtn";
import moment from "moment";

const ManagePayments = () => {
  const location = useLocation();
  const user = location.state?.user;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [allData, setAllData] = useState();
  const [editId, setEditId] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedDocumentType, setSelectedDocumentType] = useState();

  const [assignServiceFormDisplay, setAssignServiceFormDisplay] =
    useState(true);
  const [uploadDocumentFormDisplay, setUploadDocumentFormDisplay] =
    useState(false);
  const [sendPaymentLinkLoading, setSendPaymentLinkLoadind] = useState(false);

  const initValue = {
    paymentLink: "",
    // documentation: selectedTypes
  };
  const [formValue, setFormValue] = useState(initValue);

  const fetchDocumentTypes = async (items) => {
    console.log("POI40", items);

    try {
      // Call your API function
      const response = await HomeServices.getAllDocumentTypes();
      console.log("WED62", response.data, items);
      if (response && response?.status) {
        setDocumentTypes(
          response.data.filter((doc) => items.includes(doc._id))
        );
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  const [allServices, setAllServices] = useState([]);
  const fetchServices = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllServices();
      console.log("WEX53", response.data);
      if (response && response?.status) {
        setAllServices(response.data);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  console.log("jhsgdfjhakd", editId);

  const [isEdit, setIsEdit] = useState(true);
  const [editData, setEditData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({ ...prev, [name]: value }));
  };

  const [assignService, setAssignService] = useState("");
  const [paymentLink, setPaymentLink] = useState("");

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("alldasdasdd", formValue);
    // return
    const { title, description } = formValue;
    const isValid = title.trim() !== "" && description.trim() !== "";

    if (isValid) {
      if (formValue?.image1 === "" || formValue?.image2 === "") {
        return toast.error("Please Upload Images");
      } else {
        const res = await HomeServices.addBlog(formValue);
        // console.log("resCat", res)
        if (res && res?.status) {
          toast.success("Blog Added Successfully");
          fetchData();

          // navigate('/manage-category');
          setIsLoading(false);
          console.log("formValue21456", formValue);
        } else {
          toast.error(res?.message || "Something Wrong");
          setIsLoading(false);
        }
      }
    } else {
      toast.error("Please Fill All The Inputs, Including the Image.");
    }
  };

  const [serviceForDocumentUpload, setServiceForDocumentUpload] = useState({
    serviceId: "",
    assignedServiceId: "",
  });
  const handleUploadDocumentForm = (e, item) => {
    e.preventDefault();
    console.log("TRE113", item);
    setServiceForDocumentUpload({
      serviceId: item?.ServiceData?._id,
      assignedServiceId: item._id,
    });
    fetchDocumentTypes(item?.ServiceData?.documentation);
    setAssignServiceFormDisplay(false);
    setUploadDocumentFormDisplay(true);
  };

  const handleServiceNotes = (e, id, name) => {
    e.preventDefault();
    console.log("HGF124", name);
    navigate("/service-notes", {
      state: { user: user, assignedService: id, assignedServiceName: name },
    });
  };

  const updateServiceStatus = async (e, id) => {
    e.preventDefault();
    console.log("UGC134", e.target.value, id);
    const formData = {
      paymentStatus: e.target.value,
    };

    await HomeServices.updatePaymentLink(id, formData)
      .then((res) => {
        if (res && res?.status) {
          toast.success("Status updated successfully");
          fetchData();
        } else {
          toast.error(res?.message || "Failed to Update");
        }
      })
      .catch((err) => {
        toast.error(err?.message || "An error occurred");
        console.error("err", err);
      });
  };

  const serviceStatus = ["pending", "failed", "completed"];

  const columns = [
    { name: "SL No.", selector: "sln", sortable: true },
    { name: "Date", selector: "sendDate", wrap: true },
    { name: "Link", selector: "paymentLink", wrap: true },
    { name: "Payment Status", selector: "actionStatus", wrap: true },
  ];

  const fetchData = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllPaymentLink();
      console.log("MHT166", response.data);
      if (response && response?.status) {
        let arr = response?.data
          .filter((item) => item.userId === user?._id)
          .reverse()
          ?.map((ele, index) => {
            return {
              sln: index + 1,
              sendDate: moment(ele?.createdAt).format("DD-MMM-YYYY"),
              paymentLink: ele?.paymentLink || "N/A",
              paymentStatus: ele?.paymentStatus || "N/A",
              actionStatus: (
                <>
                  <div>
                    <select
                      className="form-control"
                      value={ele?.paymentStatus}
                      onChange={(e) => updateServiceStatus(e, ele._id)}
                    >
                      <option value="">
                        {ele?.paymentStatus || "Choose..."}
                      </option>
                      {serviceStatus
                        .filter((item) => item !== ele?.paymentStatus)
                        .map((item, i) => {
                          return (
                            <>
                              <option value={item} key={i}>
                                {item}
                              </option>
                            </>
                          );
                        })}
                    </select>
                  </div>
                </>
              ),
              // action: (
              //   <>
              //     <div>
              //       <button className="btn btn-success btn-sm"
              //         onClick={(e) => handleUploadDocumentForm(e, ele)}
              //       >View/Upload ({ele?.ServiceData?.documentation?.length})</button>
              //     </div>
              //   </>
              // ),
              // note: (
              //   <>
              //     <div>
              //       <button className="btn btn-warning btn-sm"
              //         onClick={(e) => handleServiceNotes(e, ele._id, ele?.ServiceData?.serviceName)}
              //       >View/Add Note ({ele?.serviceNotes?.length})</button>
              //     </div>
              //   </>
              // ),
            };
          });
        setAllData(arr);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // click on edit
  const handleEdit = (e, ele) => {
    e.preventDefault();
    console.log("FTY164", ele);

    window.scrollTo(0, 0);
    // setSelectedTypes(ele.documentation)
    setEditMode(true);
    setEditId(ele?._id);
    setFormValue({
      serviceName: ele.serviceName,
      documentation: ele.documentation,
    });
  };

  const handleDelete = async (id) => {
    console.log("deleteblogid", id);
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      console.log("result", result);
      if (result?.isConfirmed) {
        HomeServices.deleteService(id)
          .then((res) => {
            if (res && res.status) {
              toast.success("Deleted Successfully");
              fetchData();
            } else {
              toast.error(res?.message);
            }
          })
          .catch((err) => {
            console.error("Error deleting document:", err);
          });
      } else {
        console.log("Deletion canceled");
      }
    });
  };

  // const handleCheckboxChange = (event) => {
  //   const { value, checked } = event.target;
  //   setSelectedTypes((prev) =>
  //     checked ? [...prev, value] : prev.filter((type) => type !== value)
  //   );
  // };

  const handlePaymentLink = async (e) => {
    e.preventDefault();
    if (!paymentLink) return toast.error("Enter the payment link to send");
    const formData = {
      userId: user?._id,
      paymentLink: paymentLink,
    };
    console.log("VFE293", formData);
    // return

    setSendPaymentLinkLoadind(true);
    await HomeServices.addPaymentLink(formData)
      .then((res) => {
        if (res && res?.status) {
          toast.success("Sent successfully");
          fetchData();
          setPaymentLink("");
          setSendPaymentLinkLoadind(false);
        } else {
          toast.error(res?.message || "Failed to Send");
          setSendPaymentLinkLoadind(false);
        }
      })
      .catch((err) => {
        toast.error(err?.message || "An error occurred");
        console.error("err", err);
        setSendPaymentLinkLoadind(false);
      });
  };

  return (
    <>
      <CustomLoader loading={isLoading} />
      <div className="d-flex justify-content-end mt-2">
        <div className="form-header">
          <BackPageBtn backLink="/users" />
        </div>
      </div>
      {assignServiceFormDisplay && (
        <div className="d-flex justify-content-end _mt-2">
          <div className="form-header">
            <section className="piechartsBox_area">
              <form>
                <div>
                  <h1
                    style={{
                      color: "#ff9c00",
                      fontSize: "25px",
                      fontWeight: "600",
                      marginBottom: "10px",
                    }}
                  >
                    Provide Payment Link
                  </h1>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">Link URL</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter payment link url"
                      name="paymentLink"
                      value={paymentLink}
                      onChange={(e) => setPaymentLink(e.target.value)}
                    />
                  </div>
                </div>

                <div class="col-12 ">
                  <button
                    disabled={sendPaymentLinkLoading}
                    type="submit"
                    onClick={(e) => handlePaymentLink(e)}
                    class="btn btn-primaryb mt-3 addBlogBtn"
                    style={{
                      background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                      color: "#fff",
                    }}
                  >
                    {sendPaymentLinkLoading ? "Loading..." : "Send Link"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}

      <div className="d-flex justify-content-end">
        <div className="form-header">
          <section className="piechartsBox_area">
            <div>
              <div className="dateListDiv">
                <h1
                  style={{
                    color: "#ff9c00",
                    fontSize: "25px",
                    fontWeight: "600",
                    marginBottom: "10px",
                  }}
                >
                  Payments from {user?.email}
                </h1>
              </div>
            </div>

            <hr />
            <DataTable columns={columns} data={allData} pagination />
          </section>
        </div>
      </div>
    </>
  );
};

export default ManagePayments;
